import React from "react";
import profilePic from "../../images/portfolio.jpg";

export default function Home() {
  return (
    <div className="container">
      <div className="row  mt-4">
        <div className="col-md-5 my-4">
          <img
            className="rounded shadow-lg"
            src={profilePic}
            alt="profile-pic"
          ></img>
        </div>
        <div className="col-md-7">
          <h1 className="my-4">About Me</h1>
          <p className=" p-3 my-4 border-0 rounded shadow-lg">
            Hello! My name is Youssef Ojeil, I am a Full Stack Web Developer
            with a background in Electrical Engineering. In 2016, I graduated
            from UCF with a Bachelor in Electrical Engineering, from 2017 till
            2019 I worked as a Test Engineer for Micross Components, and as a
            Product Engineer at Honeywell from 2019 till 2021. In late 2021 I
            transitioned into a CTO position at a web3 startup. Part of my
            challenges and responsibilities included Web3 R&D, specifically
            pertaining to the Ethereum Ecosystem. It was expected of me to lead
            and navigate multiple dev & design teams to achieve our roadmap
            goals via integration of smart contracts, tokenization, and AR. To
            further my development knowledge and experience I completed UCF's
            full time full stack web development program in 2022.
          </p>
        </div>
      </div>

      <div className="row my-4">
        <div className="col p-3 m-4 border-0 rounded shadow-lg">
          <h1 className="my-2 ">Interests</h1>
          <ul className="list-unstyled my-4">
            <li className="list-group-item">AI</li>
            <li className="list-group-item">DeFi</li>
            <li className="list-group-item">3D Design</li>
            <li className="list-group-item">Blockchain Technology</li>
            <li className="list-group-item">
              Web3 Technology and Digital Collectibles
            </li>
          </ul>
        </div>

        <div className="col p-3 m-4 border-0 rounded shadow-lg">
          <h1 className="my-2">Hobbies</h1>
          <ul className="list-unstyled my-4">
            <li className="list-group-item">Sports</li>
            <li className="list-group-item">Gaming</li>
            <li className="list-group-item">Anime</li>
            <li className="list-group-item">
              Fluent in English Arabic and French
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
